import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-back-button',
  imports: [NgOptimizedImage],
  templateUrl: './back-button.html',
  styleUrl: './back-button.scss',
})
export class BackButton {
  @Input() onClick!: (item: any) => void;

  handleClick() {
    if (!!this.onClick) {
      this.onClick({});
    }
  }
}
